import { createSlice } from '@reduxjs/toolkit';

export interface ITabsState {}

const initialState: ITabsState = {};

const stateSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {},
});

// uncomment to export actions from the slice.
// export const { action } = stateSlice.actions;

export default stateSlice;
